// @flow
import React from 'react';
import { Box } from 'grommet';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import { injectIntl } from 'react-intl';
import Title from 'esm-web-pro/components/layout/sidePanel/Title';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import { ApiForm } from 'esm-web-pro/containers';

type Props = {
    setIsSubmitting: Function,
    title: string,
    updatingObject: Object,
    handleCreateSave: Function,
    handleEditClose: Function,
};

function MapEditForm(props: Props) {
    const {
        title, updatingObject, setIsSubmitting, handleCreateSave,
        handleEditClose,
    } = props;
    const apiFormRef = React.useRef(null);

    return (
        <Box height="100%" justify="between">
            <Box>
                <UpperContainer>
                    <Title text={title} />
                    <HorizontalLine color="grey" />
                </UpperContainer>
                <ApiForm
                    setIsSubmitting={setIsSubmitting}
                    resourceName={updatingObject.resource.name}
                    resourceArguments={updatingObject.resource.arguments}
                    excludeFields={[updatingObject.resource.geometryField]}
                    initial={{
                        ...updatingObject.layer.feature.properties,
                    }}
                    objectId={updatingObject.layer.feature.id}
                    onSave={(response) => {
                        updatingObject.layer.pm.disable();
                        return handleCreateSave();
                    }}
                    height="100%"
                    onClose={() => {
                        if (updatingObject.layer.pm.enabled()) {
                            updatingObject.layer.pm.disable();
                        }
                        return handleEditClose();
                    }}
                    ref={apiFormRef}
                    onSubmit={(values, formik) => {
                        setIsSubmitting(true);
                        values[updatingObject.resource.geometryField] = updatingObject.layer.toGeoJSON().geometry;
                        return values;
                    }}
                    onError={(res) => setIsSubmitting(false)}
                />
            </Box>
        </Box>
    );
}

export default injectIntl(MapEditForm);
